import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { Box, StyledList } from '@zillow/constellation';
import PropTypes from 'prop-types';
import React from 'react';
import { negativeMarginMixin } from '../../mixins/negativeMarginMixin.js';
import { ListContext } from './ListContext.js';
import ListItem from './ListItem.js';

var List = function List(props) {
  var attrs = props.attrs,
    appearance = props.appearance;

  // Determine list style type based on appearance
  var listStyleType;
  if (appearance === 'bullet') {
    listStyleType = 'disc';
  } else if (appearance === 'number') {
    // Find style attribute if it exists
    var styleAttr = attrs === null || attrs === void 0 ? void 0 : attrs.find(function (attr) {
      return attr.name === 'style';
    });
    // Check if listStyleType is specified in style
    var styleValue = (styleAttr === null || styleAttr === void 0 ? void 0 : styleAttr.value) || '';
    var listStyleMatch = styleValue.match(/list-style-type:\s*([^;]+)/);
    listStyleType = listStyleMatch ? listStyleMatch[1].trim() : 'decimal';
  }
  return /*#__PURE__*/React.createElement(ListContext.Provider, {
    value: props
  }, /*#__PURE__*/React.createElement(Box, _extends({
    as: StyledList
  }, props, {
    sx: {
      // Apply negative margin mixin and inherit color
      '&&&&&': Object.assign({}, negativeMarginMixin, {
        listStyleType: listStyleType
      }),
      color: 'inherit'
    }
  })));
};
List.Item = ListItem;
List.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.shape({}),
  appearance: PropTypes.oneOf(['number', 'checkmark', 'bullet', 'horizontalTable', 'none']),
  verticalSpace: PropTypes.oneOf([0, 'xs', 'sm', 'md', 'lg', 'xl'])
} : {};
List.defaultProps = {
  appearance: 'bullet',
  verticalSpace: 'none'
};
var List$1 = List;

export { List$1 as default };
